<template>
    <div :class="cn('tw-flex tw-gap-y-1.5 tw-p-4', flexClass, props.class)">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
import { computed, type HTMLAttributes } from 'vue'
import { cn } from '../utils'

const props = defineProps<{
    // eslint-disable-next-line vue/no-reserved-props
    class?: HTMLAttributes['class']
    row?: boolean
    col?: boolean
}>()

const flexClass = computed(() => {
    if (props.row) return `tw-flex-row`

    if (props.col) return `tw-flex-col`

    return ''
})
</script>
